import type { ReactNode } from 'react'

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import { Link } from '../../router/components/Link'

export { StyledIconLink }

interface Props {
  href: string
  icon: ReactNode
  title: string
}

const StyledIconLink = ({ href, icon, title }: Props) => (
  <Tooltip title={title}>
    <Link to={href} style={{ display: 'inline-block' }}>
      <IconButton>{icon}</IconButton>
    </Link>
  </Tooltip>
)
